export function getHostname(host: string) {
  return host.replace(/:[0-9]+/, '');
}
